import LeaveScheme from "@/pages/leaveManagement/components/LeaveScheme";
import dayjs from "dayjs";
import * as Yup from "yup";

// Helper function to get role type from localStorage
const getRoleType = () => {
  try {
    const loginDetails = JSON.parse(localStorage.getItem("loginDetails")) || {};
    return loginDetails?.userDetails?.roleType;
  } catch (error) {
    return null;
  }
};

const validationSchema = Yup.object({
  // NEW FIELDS
  ticketId: Yup.string()
    .trim()
    .when([], () => {
      const roleType = getRoleType();
      return roleType === "HRSS"
        ? Yup.string().notRequired()
        : Yup.string()
            .required("Ticket ID is required")
            .matches(
              /^(?!\s*$).+$/,
              "Ticket ID cannot be empty or just spaces",
            );
    }),

  mailIdDomain: Yup.string().when("mailIdRequired", {
    is: (val) => val === "Yes",
    then: (schema) => schema.required("Please Select Mail ID domain"),
    otherwise: (schema) => schema.notRequired(),
  }),

  assetRequired: Yup.string()
    .trim()
    .required("Asset Required is required")
    .matches(/^(?!\s*$).+$/, "Asset Required cannot be empty or just spaces"),

  asset: Yup.string().when("assetRequired", {
    is: (val) => val === "Yes",
    then: (schema) => schema.required("Please Select Asset"),
    otherwise: (schema) => schema.notRequired(),
  }),

  workLocationCity: Yup.string().when("workLocation", {
    is: (val) =>
      val === "Work From Home" ||
      val === "Others - Plant / Field / Other Offices",
    then: (schema) => schema.required("Please enter the Work Location City"),

    otherwise: (schema) => schema.notRequired(),
  }),

  years: Yup.string().when("experience", {
    is: (val) => val === "Experienced",
    then: (schema) => schema.required("Please Select Years"),

    otherwise: (schema) => schema.notRequired(),
  }),
  months: Yup.string().when("experience", {
    is: (val) => val === "Experienced",
    then: (schema) => schema.required("Please Select Months"),

    otherwise: (schema) => schema.notRequired(),
  }),

  firstName: Yup.string()
    .trim()
    .required("First name is required")
    .matches(/^(?!\s*$).+$/, "First name cannot be empty or just spaces"),

  middleName: Yup.string().trim(),

  lastName: Yup.string()
    .trim()
    .required("Last name is required")
    .matches(/^(?!\s*$).+$/, "Last name cannot be empty or just spaces"),

  gender: Yup.string()
    .trim()
    .required("Gender is required")
    .matches(/^(?!\s*$).+$/, "Gender cannot be empty or just spaces"),

  doj: Yup.date()
    .typeError("Invalid date")
    .required("Date of joining is required"),
  dob: Yup.date()
    .typeError("Invalid date")
    .required("Date of birth is required"),

  shift: Yup.string()
    .trim()
    .required("Shift is required")
    .matches(/^(?!\s*$).+$/, "Shift cannot be empty or just spaces"),

  swipeMethod: Yup.string()
    .trim()
    .required("Swipe method is required")
    .matches(/^(?!\s*$).+$/, "Swipe method cannot be empty or just spaces"),
  oldEmpId: Yup.string().trim(),

  // oldEmpId: Yup.string()
  //   .matches(/^(?!\s*$).+$/, "Old Employee ID cannot be empty or just spaces")
  //   .when("employeeType", {
  //     is: (val) => val === "On Roll" || val === "Transfer",
  //     then: (schema) => schema.required("Old Employee ID is required"),
  //     otherwise: (schema) => schema.notRequired(),
  //   }),

  experience: Yup.mixed().required("Experience is required"),

  ctc: Yup.string()
    .trim()
    .when([], () => {
      const roleType = getRoleType();
      return roleType === "HRSS"
        ? Yup.string().notRequired()
        : Yup.string()
            .matches(/^[0-9]+$/, "CTC must be numeric")
            .required("CTC is required")
            .matches(/^(?!\s*$).+$/, "CTC cannot be empty or just spaces");
    }),

  personalEmailId: Yup.string()
    .trim()
    .email("Invalid email format")
    .required("Personal email is required")
    .matches(/^(?!\s*$).+$/, "Email cannot be empty or just spaces"),

  primaryContactNumber: Yup.string()
    .trim()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit phone number")
    .required("Primary contact number is required"),

  secondaryContactNumber: Yup.string()
    .nullable()
    .test(
      "valid-secondary-number",
      "Enter a valid 10-digit phone number",
      (value) => !value || /^[0-9]{10}$/.test(value),
    ),

  buddyId: Yup.string()
    .trim()
    .required("HRBP is required")
    .matches(/^(?!\s*$).+$/, "Buddy cannot be empty or just spaces"),

  recruiterId: Yup.string()
    .trim()
    .required("Recruiter is required")
    .matches(/^(?!\s*$).+$/, "Recruiter cannot be empty or just spaces"),

  marketFacingTitle: Yup.string()
    .trim()
    .required("Market Facing Title is required")
    .matches(
      /^(?!\s*$).+$/,
      "Market Facing Title cannot be empty or just spaces",
    ),

  primaryReportingManager: Yup.string()
    .trim()
    .required("Primary Reporting Manager is required")
    .matches(
      /^(?!\s*$).+$/,
      "Primary Reporting Manager cannot be empty or just spaces",
    ),

  reviewer: Yup.string()
    .trim()
    .required("Reviewer is required")
    .matches(/^(?!\s*$).+$/, "Reviewer cannot be empty or just spaces"),

  divisionHeadId: Yup.string()
    .trim()
    .required("Division Head is required")
    .matches(/^(?!\s*$).+$/, "Division Head cannot be empty or just spaces"),

  mailIdRequired: Yup.string()
    .trim()
    .required("Mail Id is required")
    .matches(/^(?!\s*$).+$/, "Mail Id cannot be empty or just spaces"),

  department: Yup.string()
    .trim()
    .required("Department is required")
    .matches(/^(?!\s*$).+$/, "Department cannot be empty or just spaces"),

  designation: Yup.string()
    .trim()
    .required("Designation is required")
    .matches(/^(?!\s*$).+$/, "Designation cannot be empty or just spaces"),

  subOrganization: Yup.string()
    .trim()
    .required("Sub-organization is required")
    .matches(/^(?!\s*$).+$/, "Sub-organization cannot be empty or just spaces"),

  organization: Yup.string()
    .trim()
    .required("Organization is required")
    .matches(/^(?!\s*$).+$/, "Organization cannot be empty or just spaces"),

  attendanceFormat: Yup.string()
    .trim()
    .required("Attendance format is required")
    .matches(
      /^(?!\s*$).+$/,
      "Attendance format cannot be empty or just spaces",
    ),

  roleOfIntake: Yup.string()
    .trim()
    .required("Role of intake is required")
    .matches(/^(?!\s*$).+$/, "Role of intake cannot be empty or just spaces"),
  // roleFamily: Yup.string()
  //   .trim()
  //   .required("Sub Division is required")
  //   .matches(/^(?!\s*$).+$/, "Sub Division cannot be empty or just spaces"),

  grade: Yup.string()
    .trim()
    .required("Grade is required")
    .matches(/^(?!\s*$).+$/, "Grade cannot be empty or just spaces"),
  probationMonths: Yup.string().when("probation", {
    is: (val) => val !== "Confirmed",
    then: (schema) => schema.required("Probation Month is required"),

    otherwise: (schema) => schema.notRequired(),
  }),
  // probationMonths: Yup.string()
  //   .trim()
  //   .required("Probation Month is required")
  //   .matches(/^(?!\s*$).+$/, "Probation Month cannot be empty or just spaces"),
  probation: Yup.string()
    .trim()
    .required("Probation is required")
    .matches(/^(?!\s*$).+$/, "Probation cannot be empty or just spaces"),
  noticePeriod: Yup.string()
    .trim()
    .required("Notice Period is required")
    .matches(/^(?!\s*$).+$/, "Notice Period cannot be empty or just spaces"),

  weekOff: Yup.string()
    .trim()
    .required("Week off is required")
    .matches(/^(?!\s*$).+$/, "Week off cannot be empty or just spaces"),

  workLocation: Yup.string()
    .trim()
    .required("Work location is required")
    .matches(/^(?!\s*$).+$/, "Work location cannot be empty or just spaces"),

  manpowerOutsourcing: Yup.string()
    .trim()
    .required("Manpower outsourcing is required")
    .matches(
      /^(?!\s*$).+$/,
      "Manpower outsourcing cannot be empty or just spaces",
    ),
  mobileAccess: Yup.string()
    .trim()
    .required("Mobile access is required")
    .matches(/^(?!\s*$).+$/, "Mobile access cannot be empty or just spaces"),

  // leaveScheme: Yup.string()
  //   .trim()
  //   .required("Leave scheme is required")
  //   .matches(/^(?!\s*$).+$/, "Leave scheme is required"),
  employeeType: Yup.string()
    .trim()
    .required("Employee Type is required")
    .matches(/^(?!\s*$).+$/, "Employee Type is required"),
});

export default validationSchema;
